import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProviderProductDetailFrm } from './providerproductdetail.frm';

export const routes: Routes = [
    //  { path: 'branch/:id', loadChildren: '../branch/branch.module#BranchModule' },
    //  { path: 'docsignitems/:id', data: { reuse: true }, loadChildren: '../docsignitem/docsignitem.module#DocSignItemModule' },
    { path: '', component: ProviderProductDetailFrm },

    /*
    { path: '',
        redirectTo: 'page/user',
        pathMatch: 'full',

    }
    */
];

export const ROOTAPPNEW_ROUTER_PROVIDERS = RouterModule.forChild(routes);
